import Axios from '../baseApi';

export default{
  async fetch(deliveryProgramId) {
    return await Axios.get(`api-article/delivery-program-parameter/v1/${deliveryProgramId}`);
  },
  async update(deliveryProgramId, form) {
    return await Axios.post(`api-article/delivery-program-parameter/v1/${deliveryProgramId}`, form);
  }
}
